/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-indent */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { logoutRequest, submitFormRequest } from '../../store/page/actions';
import { ApplicationState } from '../../store';
import Button, { ButtonType } from '../common/button';
import Icon from '../common/icon';
import { bbCodeToHtml } from '../../utils/formUtils';
import { random } from '../../utils/utils';
import { useCurrentWidth } from '../common/effects';
import ES from './img/es.svg';
import DK from './img/dk.svg';
import FI from './img/fi.svg';
import PL from './img/pl.svg';
import FI_CORP from './img/fi_corp.svg';
import DK_CORP from './img/dk_corp.svg';
import './style.scss';

export enum HeaderType {
  Default = 'default',
  Steps = 'steps',
}

export enum BannerState {
  green = 'green',
  red = 'red',
  success = 'success',
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LOGOS: { [key: string]: any } = { ES, DK, FI, PL, FI_CORP, DK_CORP };

interface Link {
  title: string;
  value: string;
  links?: Link[];
}

interface BannerProps {
  title?: string;
  label?: string;
  labelSuccess?: string;
  buttonLabel?: string;
  buttonId?: string;
  buttonData?: any;
  state?: BannerState;
}

interface HeaderProps {
  type?: HeaderType;
  extra?: {
    banner?: BannerProps;
    steps?: Array<string>;
    active: number;
    numbered?: boolean;
    hidden?: Array<number>;
    links?: Link[];
    logout?: { title: string };
  };
}

const step = (
  label: string,
  id: number,
  activeId: number,
  numbered: boolean
) => (
  <div
    key={id}
    styleName={cn('header__step__item', {
      active: id === activeId,
      disabled: id !== activeId,
    })}
  >
    <div styleName="header__step__item__circle">
      {numbered ? <div styleName="header__step__item__num">{id}</div> : null}
    </div>
    <div
      styleName="header__step__item__label"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: bbCodeToHtml(label),
      }}
    />
  </div>
);

const Header: React.FC<HeaderProps> = ({ type, extra = {} }) => {
  if (!type || !Object.values(HeaderType).includes(type)) return null;
  const {
    banner = {},
    steps = [],
    active = 1,
    hidden = [],
    numbered = true,
    links = [],
    logout = { title: 'Logout' },
  } = extra;
  const sessionData = useSelector(
    (state: ApplicationState) => state.page.sessionData
  );
  const [mobileMenu, toggleMobileMenu] = useState(false);
  const homeUrl = process.env.HOME_URL || '/';
  const COUNTRY_CODE = process.env.COUNTRY_CODE || '';
  const MARKET = process.env.MARKET || '';
  const id = MARKET || COUNTRY_CODE;
  const LogoComp = LOGOS[id] ? LOGOS[id] : null;
  const dispatch = useDispatch();
  const handleLogoutClick = () => {
    dispatch(logoutRequest());
    toggleMobileMenu(false);
  };
  const handleApplyRenewalClick = () => {
    dispatch(
      submitFormRequest({
        buttonId: banner.buttonId,
        buttonData: banner.buttonData,
        form: {
          id: 'my_dashboard',
          visibility: 'visible',
          sections: [{ content: [{}] }],
        },
      })
    );
    toggleMobileMenu(false);
  };
  const width = useCurrentWidth();
  const isMob = width <= 768;
  const hasMenu = sessionData.auth || links.length > 0;

  const styleRed = {
    background: '#ff0000',
  };
  const styleGreen = {
    background: '#008000',
  };

  const renderMenu = () => {
    return (
      <>
        {links.map(i => (
          <div key={`id-${random()}`} styleName="header__menu__item">
            <a styleName="header__menu__item__link" href={i.value}>
              {i.title}
            </a>
            {isMob && i.links
              ? i.links.map(sub => (
                  <a
                    key={`id-${random()}`}
                    styleName={cn('header__menu__item__link', { sub: true })}
                    href={sub.value}
                  >
                    {sub.title}
                  </a>
                ))
              : null}
          </div>
        ))}
        {sessionData.auth && !isMob ? (
          <Button
            type={ButtonType.Normal}
            label={logout.title}
            onClick={handleLogoutClick}
          />
        ) : null}
        {sessionData.auth && isMob ? (
          <div styleName="header__menu__item" onClick={handleLogoutClick}>
            <div styleName="header__menu__item__link">{logout.title}</div>
          </div>
        ) : null}
      </>
    );
  };

  return (
    <div>
      <div
        styleName={cn('header__box', {
          default: true,
        })}
      >
        <div
          styleName={cn('header__default', {
            minilogo: sessionData.auth && COUNTRY_CODE === 'FI',
          })}
        >
          <a data-testid="logo" href={homeUrl}>
            {LogoComp ? <LogoComp /> : null}
          </a>
          {hasMenu && isMob ? (
            <>
              <div
                styleName="header__icon"
                onClick={() => toggleMobileMenu(!mobileMenu)}
              >
                <Icon value={mobileMenu ? 'close' : 'list'} />
              </div>
              <div styleName={cn('header__mobmenu', { active: mobileMenu })}>
                {renderMenu()}
              </div>
            </>
          ) : null}
          {hasMenu && !isMob ? (
            <div styleName="header__menu">{renderMenu()}</div>
          ) : null}
        </div>
      </div>
      {banner.state ? (
        <div styleName={`header${isMob ? '__mobilebanner' : '__banner'}`}>
          {banner.state === BannerState.success && banner.title ? (
            <div
              styleName={`header${
                isMob ? '__mobilebanner' : '__banner'
              }__title`}
            >
              {banner.title}
            </div>
          ) : null}
          <div styleName={`${isMob ? '' : 'header__banner__row'}`}>
            {banner.label ? (
              <div
                styleName={`header${
                  isMob ? '__mobilebanner' : '__banner'
                }__label`}
              >
                {banner.state === BannerState.success
                  ? banner.labelSuccess
                  : banner.label}
              </div>
            ) : null}
            {banner.state !== BannerState.success && banner.buttonLabel ? (
              <div styleName={`header${isMob ? '__mobilebanner' : '__banner'}`}>
                <Button
                  style={
                    banner.state === BannerState.red ? styleRed : styleGreen
                  }
                  type={ButtonType.Submit}
                  label={banner.buttonLabel}
                  onClick={handleApplyRenewalClick}
                />
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      {type === HeaderType.Steps ? (
        <div
          styleName={cn('header__box', {
            steps: true,
          })}
        >
          <div styleName="header__step">
            {steps
              .map((label, i) => ({
                label,
                num: i + 1,
                hidden: hidden.includes(i + 1),
              }))
              .filter(i => !i.hidden)
              .map(({ label, num }) => step(label, num, active, numbered))}
            <div styleName="header__step__line" />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Header;
